<template>
  <div class="scrollbar">
    <loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></loader> <message :message="response_msg" :messageType="msg_type" v-if="response_msg !=''"></message>
    <div class="col-12 inMiddle-area mt-2">
      <div class="row">
        <div class="col-12 col-md-9">
          <div class="whiteBG box-shadow">
            <div class="earningAffiliates d-flex align-items-center justify-content-between">
              <div class="card custom-card">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-title mb-3"><label class="main-content-label tx-13 font-weight-bold mb-0">Affiliate Commission</label></div>
                    <div class="card-item-body d-flex align-items-center justify-content-between">
                      <div class="card-item-stat"><h4 class="font-weight-bold" v-html=" affiliateCommList.ibcomm !=undefined && affiliateCommList.ibcomm !='' ? '$' + affiliateCommList.ibcomm : '$0' "></h4></div>
                      <div class="card-icon-img"><img src="../../../../static/fxView/images/commissionOne.svg" alt="Icon" /></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="midPlus"><span> &#43;</span></div>
              <div class="card custom-card">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-title mb-3"><label class="main-content-label tx-13 font-weight-bold mb-0">Sub-Affiliate Commission</label></div>
                    <div class="card-item-body d-flex align-items-center justify-content-between">
                      <div class="card-item-stat"><h4 class="font-weight-bold" v-html=" affiliateCommList.subibcomm !=undefined && affiliateCommList.subibcomm !='' ? '$' + affiliateCommList.subibcomm : '$0' "></h4></div>
                      <div class="card-icon-img"><img src="../../../../static/fxView/images/commissionTho.svg" alt="Icon" /></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="midPlus"><span>&#61;</span></div>
              <div class="card custom-card">
                <div class="card-body">
                  <div class="card-item">
                    <div class="card-item-title mb-3"><label class="main-content-label tx-13 font-weight-bold mb-0">Total Commission</label></div>
                    <div class="card-item-body d-flex align-items-center justify-content-between">
                      <div class="card-item-stat"><h4 class="font-weight-bold green dancingtext" v-html=" affiliateCommList.totalcomm !=undefined && affiliateCommList.totalcomm !='' ? '$' + affiliateCommList.totalcomm : '$0' "></h4></div>
                      <div class="card-icon-img"><img src="../../../../static/fxView/images/commissionTwo.svg" alt="Icon" /></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3 rightBar">
          <div class="card custom-card border-0">
            <div class="card-body">
              <div class="card-item">
                <div class="card-item-body d-flex align-items-center justify-content-between">
                  <div class="card-item-stat">
                    <div class="thisMonth">
                      <label class="main-content-label tx-13 font-weight-bold mb-0">This Month</label>
                      <h4 class="font-weight-bold" v-html=" affiliateCommList.monthcomm !=undefined && affiliateCommList.monthcomm !='' ? '$' + affiliateCommList.monthcomm : '$0' "></h4>
                    </div>
                    <div class="thisMonth mt-2">
                      <label class="main-content-label tx-13 font-weight-bold mb-0">OutStanding</label>
                      <h4 class="font-weight-bold green" v-html=" affiliateCommList.outstanding !=undefined && affiliateCommList.outstanding !='' && affiliateCommList.outstanding !=null ? '$' + Math.round((affiliateCommList.outstanding + Number.EPSILON) *100)/100 : '$0' "></h4>
                    </div>
                  </div>
                  <div class="card-icon-img"><img src="../../../../static/fxView/images/outstanding.svg" alt="Icon" /></div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottomLink"><router-link to="/withdrawal" class="grd_btn withdrawal">Withdraw</router-link></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 space">
          <div class="whiteBG box-shadow">
            <div class="tableHead-title d-flex align-items-center justify-content-between mb-2">
              <label class="font-weight-bold"> Monthly Commission </label>
              <div class="rtl d-flex align-items-center">
                <ul class="selectmotr d-flex align-items-center">
                  <li><a href="javascript:void(0);" v-bind:class="[statInfo.interval=='w' ? 'active' : '']" @click.prevent="eventInterValFl('w', 'stat')">1W</a></li>
                  <li><a href="javascript:void(0);" v-bind:class="[statInfo.interval=='m' ? 'active' : '']" @click.prevent="eventInterValFl('m', 'stat')">1M</a></li>
                  <li><a href="javascript:void(0);" v-bind:class="[statInfo.interval=='3m' ? 'active' : '']" @click.prevent="eventInterValFl('3m', 'stat')">3M</a></li>
                  <li><a href="javascript:void(0);" v-bind:class="[statInfo.interval=='' ? 'active' : '']" @click.prevent="eventInterValFl('', 'stat')">All</a></li>
                  <li>
                    <a href="javascript:void(0);" v-bind:class="[ statInfo.interval=='custom' ? 'active' : '',]" @click.prevent="openToggle=!openToggle">Custom</a>
                    <div class="mainFilterBytime modHalf">
                      <div class="cutDropdown pt-0 px-0 pb-4" :class="openToggle ? 'active' : ''">
                        <ul class="datPickerT">
                          <li class="headTitle d-flex align-items-center justify-content-between"><span>Select Date</span></li>
                          <li class="d-flex align-items-center p-3">
                            <div class="mx-datepicker form-control whiteBG pt-0">
                              <label>From</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.from"
                                name="dob1"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class=" (statInfo.from !='' && statInfo.from !='Invalid Date' ? 'active' : '') ||{'is-invalid': submittedRequest && errors.has('dob'),}"
                                :disabled="disable"
                              />
                            </div>
                            <div class="mx-datepicker">
                              <label>To</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfo.to"
                                name="dob2"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class=" (statInfo.to !='' && statInfo.to !='Invalid Date' ? 'active' : '') ||{'is-invalid': submittedRequest && errors.has('dob'),}"
                                :disabled="disable"
                              />
                            </div>
                            <div class="closeIcon" @click.prevent=" openToggle=!openToggle; statInfo.from=''; statInfo.to=''; "><feather type="x"></feather></div>
                          </li>
                          <li class="px-3 pt-3"><a href="#" @click.prevent="eventInterValFl('custom', 'stat')" class="grd_btn greenBG">Submit</a></li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="download-table-data ml-3">
                  <a title="Download Data" @click.prevent=" csvExport( affiliateCommList.records, 'monthly_transaction', 'monthly_transaction.csv' ) "><img src="../../../../static/fxView/images/excel.png" alt="Icon" /></a>
                </div>
              </div>
            </div>
            <div class="scrollable-x">
              <table class="table table-striped focus-on clientLst-table">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Revenue</th>
                    <th>Tier</th>
                    <th>Commission Earned</th>
                    <th>Sub-Affiliate</th>
                    <th>Total Commission</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in affiliateCommList.records" v-if="affiliateCommList.totalRecords > 0">
                    <td v-html=" list.date !='' && list.date !=null ? list.date : '-' "></td>
                    <td v-html=" list.totalRevenue !='' && list.totalRevenue !=null ? '$' + list.totalRevenue : '-' "></td>
                    <td v-html=" list.slab !='' && list.slab !=null ? list.slab + '%' : '-' "></td>
                    <td v-html=" list.myCommission !='' && list.myCommission !=null ? '$' + list.myCommission : '-' "></td>
                    <td v-html=" list.subIbCommission !='' && list.subIbCommission !=null ? '$' + list.subIbCommission : '-' "></td>
                    <td v-html=" list.totalCommission !='' && list.totalCommission !=null ? '$' + list.totalCommission.toFixed(2) : '-' "></td>
                  </tr>
                  <tr v-if="affiliateCommList.totalRecords==0">
                    <td colspan="10"><loader :pageloader_value="pageLoader" :type="'table'" :colspan="6" :list="affiliateCommList" v-if="pageLoader==false"></loader></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <app-pagination :getList="affiliateCommList" :pageLimit_parent="pageLimit" v-if="affiliateCommList.totalRecords > 15"></app-pagination>
          </div>
        </div>
        <div class="col-12 space">
          <commissionPerClient />
        </div>
        <div class="col-12 space">
          <div class="whiteBG box-shadow">
            <div class="tableHead-title d-flex align-items-center justify-content-between mb-2">
              <label class="font-weight-bold"> Transaction History </label>
              <div class="rtl d-flex align-items-center">
                <ul class="selectmotr d-flex align-items-center">
                  <li><a href="javascript:void(0);" v-bind:class="[ statInfoTransaction.interval=='w' ? 'active' : '',]" @click.prevent="eventInterValFl('w', 'transaction')">1W</a></li>
                  <li><a href="javascript:void(0);" v-bind:class="[ statInfoTransaction.interval=='m' ? 'active' : '',]" @click.prevent="eventInterValFl('m', 'transaction')">1M</a></li>
                  <li><a href="javascript:void(0);" v-bind:class="[ statInfoTransaction.interval=='3m' ? 'active' : '',]" @click.prevent="eventInterValFl('3m', 'transaction')">3M</a></li>
                  <li><a href="javascript:void(0);" v-bind:class="[ statInfoTransaction.interval=='' ? 'active' : '',]" @click.prevent="eventInterValFl('', 'transaction')">All</a></li>
                  <li>
                    <a href="javascript:void(0);" v-bind:class="[ statInfoTransaction.interval=='custom' ? 'active' : '',]" @click.prevent=" openToggleTransaction=!openToggleTransaction ">Custom</a>
                    <div class="mainFilterBytime modHalf">
                      <div class="cutDropdown pt-0 px-0 pb-4" :class="openToggleTransaction ? 'active' : ''">
                        <ul class="datPickerT">
                          <li class="headTitle d-flex align-items-center justify-content-between"><span>Select Date</span></li>
                          <li class="d-flex align-items-center p-3">
                            <div class="mx-datepicker form-control whiteBG pt-0">
                              <label>From</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfoTransaction.from"
                                name="dob1"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class=" (statInfoTransaction.from !='' && statInfoTransaction.from !='Invalid Date' ? 'active' : '') ||{'is-invalid': submittedRequest && errors.has('dob'),}"
                                :disabled="disable"
                              />
                            </div>
                            <div class="mx-datepicker">
                              <label>To</label>
                              <input
                                class="customflaotField mdb-select md-form form-control pt-0"
                                type="date"
                                v-model="statInfoTransaction.to"
                                name="dob2"
                                v-validate="'required|before:beforeTarget'"
                                :max="maxDate()"
                                :class=" (statInfoTransaction.to !='' && statInfoTransaction.to !='Invalid Date' ? 'active' : '') ||{'is-invalid': submittedRequest && errors.has('dob'),}"
                                :disabled="disable"
                              />
                            </div>
                            <div class="closeIcon" @click.prevent=" openToggleTransaction=!openToggleTransaction; statInfoTransaction.from=''; statInfoTransaction.to=''; "><feather type="x"></feather></div>
                          </li>
                          <li class="px-3 pt-3"><a href="#" @click.prevent=" eventInterValFl('custom', 'transaction') " class="grd_btn greenBG">Submit</a></li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="form-group parentClass has-search ml-2 mb-0 position-relative">
                  <input type="text" placeholder="search here" class="form-control dataSearh" /> <feather class="form-control-feedback text-right" type="search"></feather>
                </div>
                <div class="download-table-data ml-3">
                  <a title="Download Data" @click.prevent=" csvExport( withdrawalCommList.records, 'history_transaction', 'transaction_history.csv' ) "><img src="../../../../static/fxView/images/excel.png" alt="Icon" /></a>
                </div>
              </div>
            </div>
            <div class="scrollable-x">
              <table class="table table-striped focus-on clientLst-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Method</th>
                    <th>Amount</th>
                    <th>Fee</th>
                    <th>Total</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in withdrawalCommList.records" v-if="withdrawalCommList.totalRecords > 0">
                    <td v-html=" list.created !='' && list.created !=null ? getHumanDate(list.created) : '-' "></td>
                    <td>-</td>
                    <td v-html=" list.req_amount !='' && list.req_amount !=null ? list.req_amount : '-' "></td>
                    <td>0</td>
                    <td v-html=" list.req_amount !='' && list.req_amount !=null ? list.req_amount : '-' "></td>
                    <td>
                      <p
                        class="alert inTable"
                        :class="(list.commission_success_status==0) ? 'alert-warning' : (list.commission_success_status==1) ? 'alert-success' : 'alert-danger'"
                        v-html="(list.commission_success_status==0) ? 'Pending' : (list.commission_success_status==1) ? 'Approved' : 'Denied'"
                      >
                        <!--{{getCommissionStatus(list.commission_success_status)}}-->
                      </p>
                    </td>
                  </tr>
                  <tr v-if="withdrawalCommList.totalRecords==0">
                    <td colspan="10"><loader :pageloader_value="pageLoader" :type="'table'" :colspan="6" :list="withdrawalCommList" v-if="pageLoader==false"></loader></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <app-pagination :getList="withdrawalCommList" :pageLimit_parent="pageLimit" v-if="withdrawalCommList.totalRecords > 15"></app-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment";
import { fxViewMixins } from "@/plugins/fxView";
import commissionPerClient from "./commission-per-client";
export default {
  name: "AFFILIATE-EARNINGS",
  mixins: [fxViewMixins],
  components:{ commissionPerClient },
  data() {
    return {
      pageTitle: this.$options.name,
      search: "",
      pageLoader: false,
      openTabledata: false,
      response_msg: "",
      msg_type: "",
      page: "1",
      pageLimit: 15,
      statusCls: "",
      disable: false,
      openToggle: false,
      openToggleTransaction: false,
      openToggleCommission: false,
      submittedRequest: false,
      statInfo: {
        interval: "",
        from: "",
        to: "",
      },
      statInfoCommission: {
        interval: "",
        from: "",
        to: "",
      },
      statInfoTransaction: {
        interval: "",
        from: "",
        to: "",
      },
    };
  },
  methods: {
    maxDate() {
      // return moment().format("YYYY-MM-DD");
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(0,0)
      const dd = String(today.getDate()).padStart(0,0);
      return `${yyyy}-${mm}-${dd}`
    },
    eventInterValFl(interval, eventType) {
      if (eventType == "stat") {
        this.statInfo.interval = interval;
        if (this.statInfo.interval != "custom") {
          this.statInfo.from = this.statInfo.to = "";
          this.listing();
        } else if (
          this.statInfo.interval == "custom" &&
          this.statInfo.from != "" &&
          this.statInfo.to != ""
        ) {
          this.listing();
          //this.openToggle = !this.openToggle
        } else if (this.statInfo.interval == "") {
          this.listing();
        }
      } else if (eventType == "commission") {
        this.statInfoCommission.interval = interval;
        if (this.statInfoCommission.interval != "custom") {
          this.statInfoCommission.from = this.statInfoCommission.to = "";
          this.userListing();
        } else if (
          this.statInfoCommission.interval == "custom" &&
          this.statInfoCommission.from != "" &&
          this.statInfoCommission.to != ""
        ) {
          this.userListing();
          //this.openToggleCommission = !this.openToggleCommission
        } else if (this.statInfoCommission.interval == "") {
          this.userListing();
        }
      } else if (eventType == "transaction") {
        this.statInfoTransaction.interval = interval;
        if (this.statInfoTransaction.interval != "custom") {
          this.statInfoTransaction.from = this.statInfoTransaction.to = "";
          this.withdrawalListing();
        } else if (
          this.statInfoTransaction.interval == "custom" &&
          this.statInfoTransaction.from != "" &&
          this.statInfoTransaction.to != ""
        ) {
          this.withdrawalListing();
          //this.openToggleTransaction = !this.openToggleTransaction
        } else if (this.statInfoTransaction.interval == "") {
          this.withdrawalListing();
        }
      }
    },
    getHumanDate(date) {
      return this.$parent.dateDDMMFormat(date);
    },
    getCommissionStatus(status) {
      //console.log("status",status)
      let statusMsg = "";
      if (status == 0) {
        statusMsg = "Pending";
        this.statusCls = "alert-warning";
      } else if (status == 1) {
        statusMsg = "Approved";
        this.statusCls = "alert-success";
      } else if (status == 2) {
        statusMsg = "Denied";
        this.statusCls = "alert-danger";
      } else {
        statusMsg = "-";
      }
      return statusMsg;
    },
    listing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
          stat_interval: this.statInfo.interval,
          stat_from_interval: this.statInfo.from,
          stat_to_interval: this.statInfo.to,
        },
        localParams: { parameter: this },
      };
      this._runGetAffiliateEarning(inputJson);
    },
    userListing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
          stat_interval: this.statInfoCommission.interval,
          stat_from_interval: this.statInfoCommission.from,
          stat_to_interval: this.statInfoCommission.to,
        },
        localParams: { parameter: this },
      };
      this._runGetUserList(inputJson);
    },
    withdrawalListing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
          stat_interval: this.statInfoTransaction.interval,
          stat_from_interval: this.statInfoTransaction.from,
          stat_to_interval: this.statInfoTransaction.to,
        },
        localParams: { parameter: this },
      };
      this._runGetWithdrawalCommList(inputJson);
    },
    csvExport(arrData, type, getFileName) {
      let csv = "data:text/csv;charset=utf-8,";
      //console.log("data",arrData)
      const _that = this;
      if (type == "history_transaction") {
        csv += "Date,Method,Amount,Fee,Total,Status \n";
        arrData.forEach(function (row) {
          csv +=
            _that.getHumanDate(row.created) +
            "," +
            "-" +
            "," +
            row.req_amount +
            "," +
            0 +
            "," +
            row.req_amount +
            "," +
            _that.getCommissionStatus(row.commission_success_status);
          csv += "\n";
        });
      } else if (type == "client_commission") {
        csv +=
          "Registration Date,Client Name,Email,Country,Sub-Aff. Name,Volume Traded,Total Commission,Sub-Affiliate Comm.,My Comm.,Status \n";
        arrData.forEach(function (row) {
          let status = row.status == 1 ? "Active" : "Inactive";
          csv +=
            _that.getHumanDate(row.created) +
            "," +
            row.username +
            "," +
            row.email +
            "," +
            row.country +
            "," +
            row.RMname +
            "," +
            row.totalVolume +
            "," +
            row.totalRevenue +
            "," +
            row.subIbCommission +
            "," +
            row.myCommission +
            "," +
            status;
          csv += "\n";
        });
      } else if (type == "monthly_transaction") {
        csv +=
          "Month,Revenue,Tier,Commission Earned,Sub-Affiliate,Total Commission \n";
        arrData.forEach(function (row) {
          csv +=
            _that.getHumanDate(row.date) +
            ",$" +
            row.totalRevenue +
            "," +
            row.slab +
            ",$" +
            row.myCommission +
            ",$" +
            row.subIbCommission +
            ",$" +
            (row.myCommission + row.subIbCommission);
          csv += "\n";
        });
      }

      //display the created CSV data on the web browser
      //document.write(csv);

      const link = document.createElement("a");
      const data = encodeURI(csv);
      link.setAttribute("href", data);
      link.setAttribute("download", getFileName);
      //console.log("link",link)
      link.click();
    },
  },
  created() {
    this.setData(this.pageTitle);
    this.listing();
    this.userListing();
    this.withdrawalListing();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/ib/affiliate_earnings.vue